export enum AbschlussTyp {
  KEINER = 'KEINER',
  HAUPTSCHULE = 'HAUPTSCHULE',
  REALSCHULE = 'REALSCHULE',
  ABITUR = 'ABITUR',
  BACHELOR = 'BACHELOR',
  MASTER = 'MASTER',
  DIPLOM = 'DIPLOM',
  MEISTER = 'MEISTER',
  FACHHOCHSCHULREIFE = 'FACHHOCHSCHULREIFE',
  ABGESCHLOSSENE_BERUFSAUSBILDUNG = 'ABGESCHLOSSENE_BERUFSAUSBILDUNG'
}
